import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';

import Container from "../../../../base/components/container.js";

const blockStyles = makeStyles(theme => ({
  root: {
    marginTop: "40px"
  },
}));

const TitleBlock = (props) => {

  const classes = blockStyles();
  const { className, downloadable: { name } } = props;
  return (
    <Container>
      <div className = { clsx(classes.root, className) } >
        <h1> { name } </h1>
      </div>
    </Container>
  );
}

export default TitleBlock;
